import type { BaseBudget, Budget, BudgetIds } from 'typings'

export function hasBudgetIds(budget: unknown): budget is BudgetIds {
  if (typeof budget !== 'object' || budget === null) return false

  const b = budget as Record<string, unknown>

  return (
    typeof b.id === 'string' &&
    typeof b.allocationId === 'string' &&
    b.id.length > 0 &&
    b.allocationId.length > 0
  )
}

export const hasBaseBudget = (budget: Budget): budget is BaseBudget => {
  return (
    'amount' in budget &&
    'utilized' in budget &&
    'status' in budget &&
    budget.amount !== undefined &&
    budget.utilized !== undefined &&
    budget.status !== undefined
  )
}
